import logoLight from '../../images/mobile/logo-light.png';
import logotextLight from '../../images/mobile/logo-text-light.png';
import logoDeskLight from '../../images/desktop/logo-light.png';
import bgImageDesktopFigure from '../../images/desktop/figure-dark-desc.png';
import bgImageTabletFigure from '../../images/tablet/figure-dark-tablet.png';

export const darkTheme = {
  body: '#12191a',
  MAIN_COLOR: '#e4e6eb',
  SECONDARY_COLOR: '#b0b3b8',
  TEXT_COLOR: '#212121',
  SECONDARY_TEXT_COLOR: '#fff',
  MOBILE_MENU_TEXT_COLOR: '#9B9FAA',
  MOBILE_MENU_ACTIVE_TEXT_COLOR: '#fff',
  CALORIES_TEXT_COLOR: '#FC842D',
  BACKGROUND_COLOR: '#E5E5E5',
  SIDEBAR_COLOR: '#212121',
  SIDEBAR_TEXT_COLOR: '#282a36',
  BUTTON_COLOR: '#FC842D',
  LINE_COLOR: '#E0E0E0',
  INTAKE_DAILY_COLOR: '#242526',
  SELECT_CONTAINER_COLOR: '#1a1818',
  SELECT_PLACEHOLDER_COLOR: '#9B9FAA',
  PRODUCT_LIST_THUMB_GRADIENT: 'linear-gradient(0deg, rgba(18, 25, 26, 1), rgba(18, 25, 26, 0))',
  LOGO_MOBILE: logoLight,
  LOGO_TABLET: logotextLight,
  LOGO_DESKTOP: logoDeskLight,
  BG_FIGURE: bgImageDesktopFigure,
  BG_FIGURE_TABLET: bgImageTabletFigure,
  FILTER: 'invert(1)',
  ICONS_COLOR: '#9B9FAA',
  ICONS_COLOR_HOVER: '#fff',
  EDIT_BG_COLOR: '#242526',
};
